import React, { ReactElement } from 'react';
import { ApolloError } from '@apollo/client';
import { Modal } from '@odin-labs/components';
import { useArchiveJobsiteMutation } from 'apollo/generated/client-operations';
import { TrashIcon } from 'components/icons';
import { AlertService } from 'components/alertService';
import { getGraphQLError } from 'utils/error';
import { ArchiveJobsiteModalProps } from './types';

export function ArchiveJobsiteModal(
  props: ArchiveJobsiteModalProps,
): ReactElement {
  const { isOpen, closeModal, jobsite, refetchQueries } = props;
  const { jobsiteId, name } = jobsite ?? {};

  const [archiveJobsite, { loading }] = useArchiveJobsiteMutation({
    fetchPolicy: 'no-cache',
    onCompleted: () => {
      closeModal();
      AlertService.alert('success', 'Success', 'Jobsite successfully archived');
    },
    onError: (responseError: ApolloError) => {
      AlertService.alert(
        'danger',
        'Something went wrong!',
        getGraphQLError(responseError),
      );
    },
    variables: { jobsiteId },
    refetchQueries,
  });

  return (
    <Modal
      open={isOpen}
      setOpen={closeModal}
      size="xs"
      title={`Archive "${name}" Jobsite?`}
      titleAlignment="center"
      textAlignment="center"
      onAction={archiveJobsite}
      actionButtonTheme="danger"
      actionIcon={TrashIcon}
      actionText="Archive Jobsite"
      actionButtonWithSpinner={loading}
    />
  );
}
